import { AdUnit, AdUnitClasses } from 'googlead/components/AdUnit';
import { GPTAds } from 'googlead/GPTAds';
import { AdPositions } from 'googlead/types';
import React from 'react';
import { weSkiDestinationId } from 'components/common/PlanYourTrip/WeSki/resolver';
import { WESKI_FLEXIBLE_OPTION } from 'ots-constants';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import styles from './adunit.module.scss';
import WeSki from '../../components/common/PlanYourTrip/WeSki/WeSkiWidget';

interface IProps {
  id?: string;
  isRegion?:boolean;
}

const getWeSkiDestinationId = (id: string, isRegion:boolean) => {
  const weDestinationId = (isRegion ? weSkiDestinationId({ regionId: id }) : weSkiDestinationId({ resortId: id })) ?? WESKI_FLEXIBLE_OPTION;

  return weDestinationId;
};

const locale = getLocale();

export const SidebarAd = ({ id = '', isRegion = false }: IProps) => {
  const weSkiDestination = getWeSkiDestinationId(id, isRegion);

  return (
    <div className={styles.sticky}>
      <AdUnit
        generator={GPTAds[AdPositions.Skyscraper]}
        className={AdUnitClasses.sky}
        desktop
        mobile
        recreateOnTablet
      />
      {locale !== ELocale.IT_IT && <WeSki destinationId={weSkiDestination} />}
    </div>
  );
};
